(function ($) {
    var $cityInput = $('#js-cities-search-ajax'),
        $streetInput = $('#js-street-search-ajax'),
        $cityInputVal = $('#js-cities-search-ajax-input'),
        $streetInputVal = $('#js-street-search-ajax-input'),
        $checkButton = $('#js-check-localization'),
        $checkContent = $('#js-localization-popup-content'),
        $statusInputVal = $('#js-status-search-ajax-input'),
        $postId = $('#js-cities-search-ajax-post-id');

    var cookieLocalization = JSON.parse(unescape(getCookie('localization')));
    if (cookieLocalization) {
        var selectedCity = cookieLocalization['id'],
            selectedStreet = cookieLocalization['index'];
    }

    var lastCityTerm = "";

    function loadCityData(city) {
        city = city.trim();
        if (!city || city === lastCityTerm) return;

        lastCityTerm = city;

        $.ajax({
            url: ajax.mainUrl + '/wp-json/configurator/cities/',
            dataType: 'json',
            data: { term: city },
            success: function (response) {
                if (response.length > 0) {
                    $postId.val(response[0].id);
                    $streetInputVal.focus();
                } else {
                    $postId.val(''); 
                }
            },
            error: function () {
                setStatus('error');
            }
        });
    }

    $cityInputVal.on('keypress', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            loadCityData($(this).val());
        }
    });

    $cityInputVal.on('blur', function () {
        loadCityData($(this).val());
    });

    $streetInputVal.on('keypress', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();

            let street = $(this).val().trim();
            let postIdVal = $postId.val();

            if (!street || !postIdVal) {
                setStatus('error');
                return;
            }

            $.ajax({
                url: ajax.url,
                type: 'post',
                data: {
                    action: 'load_streets',
                    post_id: postIdVal,
                    term: street
                },
                success: function (response) {
                    if (response.data && response.data.length > 0) {
                        setStatus('success');
                    } else {
                        setStatus('error');
                    }
                },
                error: function () {
                    setStatus('error');
                }
            });
        }
    });

    $cityInput.on('change', function () {
        ajaxLoadStreets($(this).val(), false);
    });

    if (selectedCity) {
        $cityInput.trigger('change', true);
    }

    function ajaxLoadStreets(post_id, reload = false) {
        $streetInput.parent().addClass('loading');

        if (reload) {
            $streetInput.val('').prop("disabled", true);
        } else {
            $streetInput.prop("disabled", true);
        }

        $.ajax({
            url: ajax.url,
            data: {
                action: 'load_streets',
                post_id: post_id
            },
            type: 'post',
            success: function (data) {
                $streetInput.prop("disabled", false);
                $streetInput.parent().removeClass('loading');
            }
        });
        return false;
    }

    function setStatus(status) {
        $statusInputVal.val(status);
        fireModal();
    }

    $checkButton.click(function (e) {
        e.preventDefault();
    
        let city = $cityInputVal.val().trim();
        let postIdVal = $postId.val();
        let street = $streetInputVal.val().trim();
    
        if (!postIdVal && city !== '') {
            $.ajax({
                url: ajax.mainUrl + '/wp-json/configurator/cities/',
                dataType: 'json',
                data: { term: city },
                success: function (response) {
                    if (response.length > 0) {
                        $postId.val(response[0].id);
                        proceedCheck(response[0].id, street);
                    } else {
                        setStatus('error');
                    }
                },
                error: function () {
                    setStatus('error');
                }
            });
        } else {
            proceedCheck(postIdVal, street);
        }
    });
    
    function proceedCheck(postId, street) {
        if (!postId || !street) {
            setStatus('error');
            return;
        }
    
        $.ajax({
            url: ajax.url,
            type: 'post',
            data: {
                action: 'load_streets',
                post_id: postId,
                term: street
            },
            success: function (response) {
                if (response.data && response.data.length > 0) {
                    setStatus('success');
                } else {
                    setStatus('error');
                }
            },
            error: function () {
                setStatus('error');
            }
        });
    }

    function fireModal() {
        $.magnificPopup.open({
            items: {
                src: '#localization',
                type: 'inline'
            },
            fixedContentPos: false,
            fixedBgPos: true,
            overflowY: 'auto',
            closeBtnInside: true,
            preloader: false,
            midClick: true,
            removalDelay: 300,
            mainClass: 'my-mfp-zoom-in'
        });

        ajaxLoadContent($postId.val(), $streetInputVal.val(), $statusInputVal.val());
    }

    function ajaxLoadContent(city, street, status) {
        $checkContent.html('<div class="localization-modal__placeholder"><div class="loader-container"><div class="loader"></div></div></div>').addClass('loading');

        $.ajax({
            url: ajax.url,
            data: {
                action: 'load_modal_content',
                city: city,
                street: street,
                status: status
            },
            type: 'post',
            success: function (data) {
                $checkContent.html(data).removeClass('loading');

                $('[data-toggle="popover"]').popover({
                    trigger: 'focus'
                });
            }
        });

        return false;
    }

})(jQuery);